import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants'


/*

Props:


*/

const StyledDiv = styled.div`
  font-family: 'Nunito', sans-serif;
  font-weight: ${props => (props.fontWeight) ? props.fontWeight : '100'};    
  font-size: ${props => (props.fontSize) ? props.fontSize+'px' : '14px'};
  color: ${props => (props.color) ? props.color : '#4AC4D1'};
`;

const SecondaryText = ({ styles, children, ...rest }) => (
  <StyledDiv style = {styles} {...rest}>
      { children }
  </StyledDiv>
)

export default SecondaryText



// WEBPACK FOOTER //
// ./src/js/components/TextModifiers/SecondaryText.jsx